<template>
	<div>
		<!-- BEGIN breadcrumb -->
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item"><a href="javascript:;">Extra</a></li>
			<li class="breadcrumb-item active">Cookie Acceptance Banner</li>
		</ol>
		<!-- END breadcrumb -->
		<!-- BEGIN page-header -->
		<h1 class="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>
		<!-- END page-header -->
		<!-- BEGIN panel -->
		<div class="panel panel-inverse">
			<div class="panel-heading">
				<h4 class="panel-title">Panel Title here</h4>
				<div class="panel-heading-btn">
					<a href="javascript:;" class="btn btn-xs btn-icon btn-default" data-toggle="panel-expand"><i class="fa fa-expand"></i></a>
					<a href="javascript:;" class="btn btn-xs btn-icon btn-success" data-toggle="panel-reload"><i class="fa fa-redo"></i></a>
					<a href="javascript:;" class="btn btn-xs btn-icon btn-warning" data-toggle="panel-collapse"><i class="fa fa-minus"></i></a>
					<a href="javascript:;" class="btn btn-xs btn-icon btn-danger" data-toggle="panel-remove"><i class="fa fa-times"></i></a>
				</div>
			</div>
			<div class="panel-body">
				Panel Content Here
			</div>
		</div>
		<!-- END panel -->
		
		
		<div v-show="showBanner">
			<div class="alert alert-dismissible fade show bg-inverse-transparent-9 text-white position-fixed rounded-0 m-0 d-md-flex align-items-center px-xl-5 py-xl-4 pt-4 start-0 end-0 bottom-0" style="z-index: 1020;">
				<div class="flex-fill">
					<h4>This website uses cookies</h4>
					<p class="mb-0">
						We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.
					</p>
				</div>
				<div class="ps-xl-4 pt-xl-0 pt-3">
					<button class="btn btn-outline-white btn-lg w-150px" v-on:click="hideBanner()">Accept</button>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
	data() {
		return {
			showBanner: true
		}
	},
	methods: {
		hideBanner: function() {
			this.showBanner = false;
		}
	}
}
</script>